import(/* webpackMode: "eager", webpackExports: ["LocalBuzzDealsExplorer"] */ "/vercel/path0/app/components/local-buzz/LocalBuzzExplorers.tsx");
